import { render, staticRenderFns } from "./GenericDescriptionForm.vue?vue&type=template&id=58786e1c&"
import script from "./GenericDescriptionForm.vue?vue&type=script&lang=js&"
export * from "./GenericDescriptionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports